import React from 'react';
import { IOldIconProps } from './type';

const SocialFacebook: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.417 22.852H1.88c-.67 0-1.214-.544-1.214-1.215V2.066c0-.67.544-1.214 1.214-1.214h19.572c.67 0 1.214.543 1.214 1.214v19.571c0 .67-.544 1.215-1.214 1.215h-5.606v-8.52h2.86l.428-3.32h-3.288v-2.12c0-.961.267-1.616 1.645-1.616l1.758-.001v-2.97c-.304-.04-1.348-.13-2.562-.13-2.535 0-4.27 1.547-4.27 4.388v2.449H9.55v3.32h2.867v8.52z"
        fill={color}
      />
    </svg>
  );
};

export default SocialFacebook;
